<template>
  <div
    v-if="item"
    class="container c-lg:c-px-4 c-px-2"
  >
    <div
      v-if="itemPosition === 'bottom'"
      class="shadow c-lg:c-mx-5 c-rounded-lg"
    >
      <div class="row c-m-0 c-justify-center bg-white c-rounded-lg c-pt-5 overflow-hidden">
        <!-- Title and description -->
        <div class="c-lg:col-10">
          <header class="c-mb-5 text-center">
            <h2 class="c-mb-3 c-md:c-mb-4">
              {{ item.title || item.headline }}
            </h2>
            <p
              class="text-sm-c"
              v-html="item.text"
            />
          </header>
        </div>
        <div class="col-12 c-px-0">
          <div class="embed-responsive embed-responsive-4by3 c-mb-0">
            <RemoteResponsiveImage
              :product-image-data="item.image || item.data"
              img-class="embed-responsive-item image-contain"
              :alt="item.title"
              sizes="100vw"
            />
          </div>
          <a
            :href="item.link"
            class="stretched-link"
          />
        </div>
      </div>
    </div>

    <div
      v-if="itemPosition === 'top'"
      class="shadow c-lg:c-mx-5 c-rounded-lg"
    >
      <div class="row c-m-0 c-justify-center bg-white c-rounded-lg c-pb-5 overflow-hidden">
        <div class="col-12 c-px-0 c-lg:order-1 order-2">
          <div class="embed-responsive embed-responsive-4by3 c-mb-0">
            <RemoteResponsiveImage
              :product-image-data="item.image || item.data"
              img-class="embed-responsive-item image-contain"
              :alt="item.title || item.headline"
              sizes="100vw"
            />
          </div>
          <a
            :href="item.link"
            class="stretched-link"
          />
        </div>
        <!-- Title and description -->
        <div class="c-lg:col-10 c-lg:order-2 order-1">
          <header class="c-mt-5 c-mb-5 c-lg:c-mb-0 text-center c-px-4">
            <h2 class="c-mb-3 c-md:c-mb-4">
              {{ item.title || item.headline }}
            </h2>
            <p class="text-sm-c">
              {{ item.text }}
            </p>
          </header>
        </div>
      </div>
    </div>

    <div
      v-if="itemPosition === 'right'"
      class="shadow c-lg:c-mx-5 c-rounded-lg"
    >
      <div class="flex c-m-0 c-justify-center bg-white c-rounded-lg overflow-hidden c-flex-wrap">
        <!-- Title and description -->
        <div class="c-lg:col-6 col-12 flex c-justify-end c-items-center">
          <div class="col-11 c-pr-5">
            <header class="c-mb-5 c-mt-5 c-lg:text-left text-center">
              <h2 class="c-mb-3 c-md:c-mb-4">
                {{ item.title || item.headline }}
              </h2>
              <p class="text-sm-c c-mb-0">
                {{ item.text }}
              </p>
            </header>
          </div>
        </div>
        <div class="c-lg:col-6 col-12 c-px-0">
          <div class="embed-responsive embed-responsive-4by3 c-mb-0 h-100">
            <RemoteResponsiveImage
              :product-image-data="item.image || item.data"
              img-class="embed-responsive-item image-cover"
              :alt="item.title"
              sizes="100vw"
            />
          </div>
          <a
            :href="item.link"
            class="stretched-link"
          />
        </div>
      </div>
    </div>
    <div
      v-if="itemPosition === 'left'"
      class="shadow c-lg:c-mx-5 c-rounded-lg"
    >
      <div class="flex c-m-0 c-justify-center bg-white c-rounded-lg overflow-hidden c-flex-wrap">
        <div class="c-lg:col-6 col-12 c-px-0 c-lg:order-1 order-2">
          <div class="embed-responsive embed-responsive-4by3 c-mb-0 h-100">
            <RemoteResponsiveImage
              :product-image-data="item.image || item.data"
              img-class="embed-responsive-item image-cover"
              :alt="item.title"
              sizes="100vw"
            />
          </div>
          <a
            :href="item.link"
            class="stretched-link"
          />
        </div>
        <!-- Title and description -->
        <div class="c-lg:col-6 col-12 flex c-lg:order-2 order-1 c-items-center">
          <div class="col-11 c-pl-5">
            <header class="c-mb-5 c-mt-5">
              <h2 class="c-mb-3 c-md:c-mb-4">
                {{ item.title || item.headline }}
              </h2>
              <p class="text-sm-c c-mb-0">
                {{ item.text }}
              </p>
            </header>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import RemoteResponsiveImage from '@/components/general/BaseRemoteResponsiveImage.vue'

defineProps({
  item: {
    type: Object,
    required: true,
  },
  itemPosition: {
    type: String,
    required: true,
  },
})
</script>
